import { Routes } from "@angular/router";
import themes from "src/domain/themes";

const childRoutes: Routes = [
  {
    path: "",
    loadComponent: () =>
      import("src/components/pages/start-page/start-page.component").then(
        (m) => m.StartPageComponent,
      ),
    data: {
      [Symbol.for("TBO:HIDE_CAR_OR_NO_DEALER_WARNING")]: true,
    },
  },
  {
    path: "faq",
    loadComponent: () =>
      import("src/components/pages/faq-page/faq-page/faq-page.component").then(
        (m) => m.FaqPageComponent,
      ),
    data: {
      [Symbol.for("TBO:HIDE_CAR_OR_NO_DEALER_WARNING")]: true,
    },
  },
  {
    path: "product/:sku",
    loadComponent: () =>
      import("src/components/pages/product-page/product-page.component").then(
        (m) => m.ProductPageComponent,
      ),
  },
  {
    path: "search",
    loadComponent: () =>
      import("src/components/pages/search-page/search-page.component").then(
        (m) => m.SearchPageComponent,
      ),
  },
  {
    path: "terms",
    loadComponent: () =>
      import("src/components/pages/terms-page/terms-page.component").then(
        (m) => m.TermsPageComponent,
      ),
    data: {
      [Symbol.for("TBO:HIDE_CAR_OR_NO_DEALER_WARNING")]: true,
    },
  },
  {
    path: "cookies",
    loadComponent: () =>
      import("src/components/pages/cookie-info-page/cookie-info-page.component").then(
        (m) => m.CookieInfoPageComponent,
      ),
    data: {
      [Symbol.for("TBO:HIDE_CAR_OR_NO_DEALER_WARNING")]: true,
    },
  },
  {
    path: "thank-you/:shoppingCartId",
    loadComponent: () =>
      import("src/components/pages/thank-you-page/thank-you-page.component").then(
        (m) => m.ThankYouPageComponent,
      ),
  },
  {
    path: "category/:categoryId/:slug",
    loadComponent: () =>
      import("src/components/pages/category-page/category-page.component").then(
        (m) => m.CategoryPageComponent,
      ),
  },
  {
    path: "checkout",
    loadComponent: () =>
      import("src/components/pages/checkout-page/checkout-page.component").then(
        (m) => m.CheckoutPageComponent,
      ),
  },
];

export const routes: Routes = [
  {
    path: "**",
    loadComponent: () =>
      import("src/components/pages/not-found-page/not-found-page.component").then(
        (m) => m.NotFoundPageComponent,
      ),
  },
];

themes.forEach((t) => {
  routes.unshift({ path: t, children: childRoutes });
});
